/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./EventGroupActions',
	'../../../../app/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function(EventGroupActions, stringResources, ContentActionsProviderAPI) {

	class CreateEventGroupAction extends EventGroupActions {
		constructor({ features }) {
			super({ features: features });
			features.ContentActions.registerProvider('createFilterGroup', this.getAPI());
		}

		getContentActionList(idList) {
			if (this._isAvailable(idList)) {
				return [{
					name: 'createFilterGroup',
					label: stringResources.get('toolbarActionCreateFilterGroup'),
					icon: this._features['Icons'].getIcon('new-link').id,
					actions: {
						apply: this.execute.bind(this, idList)
					},
					disabled: this.isDisabled.bind(this, idList),
					type: 'Button',
					section: ContentActionsProviderAPI.ACTION_SECTION.DASHBOARD,
					order: 60,
					update: true
				}];
			} else {
				return [];
			}
		}

		execute(idList) {
			this._features['EventGroups'].createGroup(idList);
		}

		isDisabled(idList){
			if (this._isStaticWidget(idList)) {
				return true;
			}
			/*
			 * if the selection contains only 1 distinct group and the selection contains every widget in that group,
			 * then disable the "Create event group" button
			 */
			let distinctGroupIdsInSelection = this._getDistinctGroupIdsInSelection(idList);
			let numberOfWidgetsInGroup = this._features['EventGroups'].getContentIdList(distinctGroupIdsInSelection[0]).length;
			if(distinctGroupIdsInSelection.length === 1 && idList.length === numberOfWidgetsInGroup){
				return true;
			}
			/*
			 * Also, if more than 5 groups will result from the execution of a create group event, then disable the button.
			 * count represents the number of groups that will be eliminated after disconnecting
			 */
			let count = this._getCountGroupsAffected(idList);
			if(this.getNumberOfGroups(idList) - count + 1> 5){
				return true;
			}
			return false;
		}
	}
	return CreateEventGroupAction;
});
